import Home from '../components/Graph'

let routes = {
    path: '/graph',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/graph',
          name: 'Dashboard',
          component: Home
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/graph.js